<template>
  <div>
    <div v-if="isPC" class="container">
      <div>
        <h1 class="title">{{ $t('Home.Banner.Tips1') }}</h1>
        <p class="subtitle">
          {{ $t('Home.Banner.Tips2') }}
        </p>
      </div>
      <div class="banner">
        <el-carousel :autoplay="false" arrow="always" :height="productBoxHeight" :indicator-position="indicator">
          <el-carousel-item v-for="(item, index) in carouselProduct" :key="index">
            <div class="f-b-c banner-box">
              <div class="product-item" ref="ossImg" v-for="(product, i) in item" :key="i">
                <a v-if="product.productSeoSearchTerm" :href="'/product-detail'+ product.productSeoSearchTerm" target="_blanck" >
                  <oss-img :width="290" :height="400" :src="product.images" :alt="product.productName" />
                </a>
                <oss-img :width="290" :height="400" v-else :src="product.images" :alt="product.productName" @click="checkSeoSearchTerm(product.productSeoSearchTerm)" />
                <div class="new-icon" >
                  <span>{{ $t('Components.Product.New') }}</span>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div v-else class="mobile-container">
      <div>
        <h1 class="title">{{ $t('Home.Banner.Tips1') }}</h1>
        <p class="subtitle">
          {{ $t('Home.Banner.Tips2') }}
        </p>
      </div>
      <div class="banner">
        <el-carousel :autoplay="false" arrow="always" :height="mobileProductBoxHeight" :indicator-position="indicator">
          <el-carousel-item v-for="(item, index) in carouselProduct" :key="index">
            <div class="f-b-c banner-box">
              <div class="product-item" ref="ossImg" v-for="(product, i) in item" :key="i">
                <a v-if="product.productSeoSearchTerm" :href="'/product-detail'+ product.productSeoSearchTerm" target="_blanck">
                  <oss-img :width="62" :height="83" :src="product.images" :alt="product.productName" />
                </a>
                <oss-img :width="62" :height="83" v-else :src="product.images" :alt="product.productName" @click="checkSeoSearchTerm(product.productSeoSearchTerm)" />
                <div class="new-icon" >
                  <!-- <span>{{ $t('Components.Product.New') }}</span> -->
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import bus from '@/util/bus.js'

const carouselProduct = []
export default {
  name: 'Banner',
  data() {
    return {
      productList: [], // 商品列表
      listParams: {
        pageSize: 100,
        pageNumber: 1,
        materialArray: [],
        minPrice: 0,
        maxPrice: 200,
        sortType: 'desc',
        sortName: 1,
        supplierLevels: []
      },
      indicator: 'none',
      carouselProduct,
      productBoxHeight: '400px',
      mobileProductBoxHeight: '83px'
    }
  },

  mounted() {
    this.getProductList() // 调用获取商品列表的方法
    window.onresize = () => {
      this.productBoxHeight = this.$refs.ossImg[0].clientHeight + 'px'
    }
  },
  computed: {
    isNew() {
      return (date) => {
        return date > (Date.now() - 29 * 24 * 60 * 60 * 1000)
      }
    }
  },
  methods: {
    // 获取详情并跳转
    toProductDetail(id) {
      console.log(this.jumpPath)
      if (this.jumpPath) {
        this.$router.push(this.jumpPath)
      } else {
        this.$record({
          eventType: 'click',
          eventId: `${this.$route.meta.pageId}_${this.kklocation}_click`,
          value: JSON.stringify({ kkProductId: id })
        })
        if (this.reportType === 'activity') {
          this.$record({
            eventType: 'click',
            eventId: `allActivityProduct_click`,
            value: JSON.stringify({ discountId: this.product.discountId, type: 'activity' })
          })
        }
        this.jumpDetailSeo(id, null, null, null)
      }
    },
    // 检查商品seo搜索词是否存在
    checkSeoSearchTerm(searchTerm) {
      if (!searchTerm) {
        return this.$message.warning(this.$t('Components.Product.DetailHint'))
      }
    },
    getProductList() {
      // this.total = 0
      const listParams = { ...this.listParams }
      API.getOpenNewInProductList(listParams).then(result => {
        this.productList = result.data.list.slice(0, 15)
        this.carouselProduct = []
        // 按每五个为一组处理 productList 数据
        let group = []
        for (const item of this.productList) {
          if (group.length === 5) {
            this.carouselProduct.push([...group])
            group = []
          }
          group.push(item)
        }
        // 如果还有剩余的不足五个的项，将其添加到最后一个组
        if (group.length > 0) {
          this.carouselProduct.push([...group])
        }
        this.total = result.data.total
      }).finally(() => {
        this.listLoading = false
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial',
    'Sans-serif' !important;
  .banner-box {
    height: 100%;
  }
  .title {
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 36px;
    color: #303133;
    line-height: 48px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 16px;
  }
  .subtitle {
    font-family: Poppins, Poppins;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 56px;
    margin-top: 16px;
  }

  .banner {
    margin-top: 48px;
    .product-item {
      position: relative;
      margin-right: 16px;
      height: 100%;
      width: 20%;
      border-radius: 4px 4px 4px 4px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px 4px 4px 4px;
        object-fit: cover;
      }
      .new-icon {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 90;
        span {
          display: inline-block;
          line-height: 20px;
          width: 45px;
          height: 20px;
          background: #9ac331;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          color: #fff;
          flex-shrink: 0;
        }
      }

    }
    .product-item:nth-last-child() {
      margin-right: 0;
    }
    /deep/.el-carousel__arrow {
      color: #000000;
      font-weight: 800;
      font-size: 18px;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.14);
      border: none;
      [class^='el-icon-'] {
        font-weight: 1000;
      }
    }
  }
}

.mobile-container {
  padding-top: 48px;
  .banner-box {
    height: 100%;
  }
  .title {
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 20px;
    color: #303133;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 12px;
  }
  .subtitle {
    font-family: Poppins, Poppins;
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    padding: 0 20px;
    margin-bottom: 32px;
  }

  .banner {
    margin-bottom: 12px;
    .product-item {
      position: relative;
      width: 62px;
      height: 83px;
      margin-right: 8px;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .new-icon {
        display: inline-block;
        position: absolute;
        top: 4px;
        left: 4px;
        z-index: 90;
        width: 26px;
        height: 12px;
        background: url('https://img.kakaclo.com/web-img/home/home2.0/Slice%20207%402x.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;

        // span {
        //   line-height: 12px;
        //   background: #9ac331;
        //   font-size: 8px;
        //   font-weight: bold;
        //   text-align: center;
        //   color: #fff;
        //   flex-shrink: 0;
        // }
      }
    }
    .product-item:nth-last-child() {
      margin-right: 0;
    }
    /deep/.el-carousel__arrow {
      width: 28px;
      height: 28px;
      color: #000000;
      font-weight: 800;
      font-size: 18px;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.14);
      border: none;
    }
    /deep/.el-carousel__arrow--left {
      left: 0px;
    }
    /deep/.el-carousel__arrow--right {
      right: 0px;
    }
  }
}
</style>
